import React from "react";
import LoginColumn from "../../teacher/LoginColumn";
import LoginContainer from "../../teacher/LoginContainer";
import LoginForm from "../../teacher/LoginForm";
import "../../teacher/TeacherLogin.css";

export default function TeacherLandingPage() {
  return (
    <LoginColumn>
      <LoginContainer>
        <LoginForm />
      </LoginContainer>
    </LoginColumn>
  );
}
